import { render, staticRenderFns } from "./DashboardSkeletonLoader.vue?vue&type=template&id=04b302d9&scoped=true&"
import script from "./DashboardSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./DashboardSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSkeletonLoader.vue?vue&type=style&index=0&id=04b302d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b302d9",
  null
  
)

export default component.exports